import { createSlice } from "@reduxjs/toolkit";

const initialState: OrderState = {
  // Existing Service Provider
  orderType: "New Order",
  hasExistingServiceProvider: false,
  internalPortin: false,

  // Order
  plan: {
    id: 0,
    name: "",
    price: "",
  },
  automaticNumberSelection: false,
  bundles: [],

  // Select Number
  msisdnNumber: "",

  // Customer Information
  salutation: "Mr",
  gender: "M",
  name: "",
  nricNumber: "",
  email: "",
};

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrder: (state, action) => {
      Object.assign(state, action.payload);
    },
    resetOrder: () => initialState,
  },
});

export const { setOrder, resetOrder } = orderSlice.actions;
export default orderSlice.reducer;
